const storageKey = 'accessToken';
import store from "../../state/store";
export default class AuthStoreService {

    getToken() {
        return localStorage.getItem(storageKey);
    }

    setToken(token) {
        localStorage.setItem(storageKey, token);
        store.dispatch('auth/setCurrenUser',this.getTokenData());
    }
    setRefreshToken(refreshToken){
        localStorage.setItem('refreshToken', refreshToken);
    }
    setUserVerificationStatus(status) {
        localStorage.setItem('isVerifiedUser', status);
        store.dispatch('auth/setVerificationStatus',status);
    }
    setUserDetails(data){
        localStorage.setItem('userDetails', JSON.stringify(data));
    }
    setCorporateDetails(data){
        localStorage.setItem('CorpDetails', JSON.stringify(data))
    }
    setForcePassword(data){
        localStorage.setItem('ForcePasswordReset', data)

    }
    removeToken() {
        localStorage.removeItem(storageKey);
    }

    isSignedIn() {
        return !!this.getToken();
    }

    getTokenData() {
        const token = this.getToken();
        return token;
        // console.log('token',token)
        // if (token) {
        //     return JSON.parse(atob(token.split('.')[1]));
        // }
        // return {};
    }

    setUserPages(userPages) {
        localStorage.setItem("UserPages", userPages)
    }
    setUserMenus(userPages) {
        localStorage.setItem("Menus",JSON.stringify(userPages))
    }

    setUserTaskActions(taskActions) {
        localStorage.setItem("TaskActions", taskActions)
    }

    getUserPages() {
        return JSON.parse(localStorage.getItem("UserPages"));
    }

    getUserTaskActions() {
        return JSON.parse(localStorage.getItem("TaskActions"));
    }

    logOut() {
        localStorage.removeItem("perfromEKYC");
        localStorage.removeItem("canSkipEKYC");
        localStorage.clear();
    }
    setclaimStatus(status){
        localStorage.setItem("claimstatus", status);
    }
    setSSMReviewStatus(status) {
        console.log(status, 'status');
        localStorage.setItem("ssmReview", status);
    }
    setSSMExpiryStatus(status) {
        console.log(status, 'status');
        localStorage.setItem("ssmExpiry", status);
    }
    setSSMExpiryMessage(status) {
        console.log(status, 'status');
        localStorage.setItem("ssmExpiryMessage", status);
    }
    setCanStaffTopUp(status){
        localStorage.setItem('CanTopUp',status)
    }
    setRejectedSteps(steps){
        localStorage.setItem('rejectSteps',steps)
    }
    setCorporateStatus(status){
        localStorage.setItem('CorporateStatus',status)
    }
    setUserImage(imageUrl){
        localStorage.setItem('userImageUrl',imageUrl)
    }
    setEKYCPerformanceStatus(status) {
        localStorage.setItem("perfromEKYC", status);
    }
    setEKYCCanSkipStatus(status) {
        localStorage.setItem("canSkipEKYC", status);
    }
}